import { o as c } from "../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/format-Cc3xCl5M.js";
const i = (t, o) => {
  const u = (e) => {
    if (!isNaN(Number(e)))
      return Number(e);
    for (let r = 0; r <= 9; r++)
      if (c(r, t) === e)
        return r;
    throw new Error(`Unrecognized digit '${e}' for locale '${t}'`);
  };
  let n = 0, l = 1;
  const a = o.value.replace(/[,٬.’  '\s]/g, "");
  for (let e = a.length - 1; e >= 0; e--)
    n += u(a[e]) * l, l *= 10;
  return { ...o, value: n };
};
export {
  i as convertFormattedNumberBackToNumber
};
